import { CreateAttachmentHandler } from '../../types/CreateAttachmentHandler';
import { FilePickerAction, FileProviderItemViewState, SelectedFilesSource } from 'owa-filepicker';
import {
    onCloudFilesSelected,
    onLocalFilesSelected,
    onRecentAttachmentFilesSelected,
} from '../onFilesSelected';

export default function attachFilesForSelectedAction(
    createAttachmentHandler: CreateAttachmentHandler,
    selectedFiles: File[] | FileProviderItemViewState[],
    source: SelectedFilesSource,
    action: FilePickerAction
) {
    if (source === SelectedFilesSource.LocalComputerFiles) {
        onLocalFilesSelected(
            createAttachmentHandler,
            <File[]>selectedFiles,
            action === FilePickerAction.Insert,
            action === FilePickerAction.Share
        );
    } else if (source === SelectedFilesSource.ProviderFiles) {
        const files = <FileProviderItemViewState[]>selectedFiles;
        if (action !== FilePickerAction.AttachAndShare) {
            onCloudFilesSelected(createAttachmentHandler, files, action === FilePickerAction.Share);
        } else {
            onRecentAttachmentFilesSelected(createAttachmentHandler, files);
        }
    }
}
